import { render, staticRenderFns } from "./ConfirmDeleteOverlay.vue?vue&type=template&id=405a7ada&scoped=true"
import script from "./ConfirmDeleteOverlay.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405a7ada",
  null
  
)

export default component.exports